module.exports = __webpack_public_path__ + "img/banner_3.f0d9ac64.jpg";